// extracted by mini-css-extract-plugin
module.exports = {"container":"ManualPay_container__NwDK_","label":"ManualPay_label__2CyfG","handle":"ManualPay_handle__3WPSG","reason":"ManualPay_reason__1dSjO","content":"ManualPay_content__3VXSS"};